import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRepeatedDate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M1.75 3.783a1.1 1.1 0 0 1 1.1-1.1H4.5a.55.55 0 1 1 0 1.1H2.85V16.24H4.5a.55.55 0 0 1 0 1.1H2.85a1.1 1.1 0 0 1-1.1-1.1zm5.835.735a.63.63 0 0 0-.63.63v2.76a.63.63 0 1 0 1.26 0v-.75h2.82a.63.63 0 0 0 0-1.26h-2.82v-.75a.63.63 0 0 0-.63-.63" />
    <path
      fillRule="evenodd"
      d="M12.415 4.518a.63.63 0 0 0-.63.63v2.76a.63.63 0 1 0 1.26 0v-.75h.75a.06.06 0 0 1 .06.06v1.44h-7.71v-1.44a.06.06 0 0 1 .06-.06.63.63 0 1 0 0-1.26 1.32 1.32 0 0 0-1.321 1.32v6.21a1.32 1.32 0 0 0 1.32 1.32h7.59a1.32 1.32 0 0 0 1.32-1.32v-6.21a1.32 1.32 0 0 0-1.32-1.32h-.75v-.75a.63.63 0 0 0-.63-.63Zm-6.269 8.91v-3.51h7.708v3.51a.06.06 0 0 1-.06.059H6.206a.06.06 0 0 1-.059-.06Z"
      clipRule="evenodd"
    />
    <path d="M17.15 2.683a1.1 1.1 0 0 1 1.1 1.1V16.24a1.1 1.1 0 0 1-1.1 1.1H15.5a.55.55 0 1 1 0-1.1h1.65V3.783H15.5a.55.55 0 1 1 0-1.1z" />
  </svg>
);
export default SvgRepeatedDate;
